import React, { ReactNode } from 'react'
import { Wrapper } from './Chip.styled'

const Chip = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <Wrapper className={className}>{children}</Wrapper>
}

export default Chip
